import Tab from "components/DesignSystem/Tab/Tab";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useSecondaryNav } from "components/AppLayout/SecondaryNavContext";
function TaskTabBar({ defaultValue }) {
  const { isCpa, isCpaInkleServiceAdmin, isForeignCA, isAdmin } =
    useRoleBasedView();
  const { active: secondaryNavActive } = useSecondaryNav();

  let tabNames;
  if (isCpaInkleServiceAdmin || isCpa) {
    const fcaTabName = isForeignCA
      ? []
      : [
          ...(isAdmin
            ? [
                {
                  name: "Bookkeeping tracker",
                  route: "/admin/bookkeeping-tracker",
                },
              ]
            : []),
          {
            name: "1120 Tracker",
            route: "/admin/task-1120-tracker",
          },
          ...(isAdmin
            ? [{ name: "Sales Tax Tracker", route: "/admin/salestax-tracker" }]
            : []),
        ];

    const deadlinesTab = isAdmin
      ? [{ name: "Deadlines", route: "/admin/filings-deadlines-dashboard" }]
      : [];

    tabNames = [
      {
        name: "All filings",
        route: "/admin/filings",
      },
      ...deadlinesTab,
      {
        name: "My filings",
        route: "/admin/myfilings",
      },
      ...fcaTabName,
    ];
  } else {
    tabNames = [
      {
        name: "All filings",
        route: "/admin/filings",
      },
    ];
  }

  if (secondaryNavActive) {
    return null;
  }

  return (
    <div className="t-box-border t-w-full t-border t-border-l-0 t-border-r-0 t-border-t-0 t-border-solid t-border-neutral-20 t-pl-5">
      <Tab.Root defaultValue={`/${defaultValue}`}>
        <Tab.List>
          {tabNames.map(({ name, route }) => {
            return (
              <Tab.NavTrigger exact value={route} omitUrl key={route}>
                {name}
              </Tab.NavTrigger>
            );
          })}
        </Tab.List>
      </Tab.Root>
    </div>
  );
}

export default TaskTabBar;
